import { render, staticRenderFns } from "./rechargeOrder.vue?vue&type=template&id=2c65fe6d&scoped=true"
import script from "./rechargeOrder.vue?vue&type=script&lang=js"
export * from "./rechargeOrder.vue?vue&type=script&lang=js"
import style0 from "./rechargeOrder.vue?vue&type=style&index=0&id=2c65fe6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c65fe6d",
  null
  
)

export default component.exports